// extracted by mini-css-extract-plugin
module.exports = {"content":"HeaderContent_content__4wGF6","descrption":"HeaderContent_descrption__1KDa2"};